/**
 * Validates react-final-form values using a Yup schema.
 *
 * @param {object} values - The form values to validate.
 * @param {object} schema - The Yup schema to use for validation.
 * @returns {Promise<object>} A Promise that resolves to an object containing validation errors, if any.
 */
const validate = async (values, schema) => {
  try {
    await schema.validate(values, { abortEarly: false });
  } catch (errors) {
    return errors.inner?.reduce((acc, error) => {
      acc[error.path] = error.message;
      return acc;
    }, {});
  }
};

export default validate;
